import React from "react";
import data from "./data.json";
import { useState } from "react";

let i = 1;

const Tracker = () => {
  let [frequency, setFrequency] = useState(0);
  return (
    <>
      <div className="left">
        <section className="profile">
          <div className="box">
            <img src="./images/image-jeremy.png" alt="" />
            <div className="info">
              <p>Report for</p>
              <h2 className="name">Jeremy Robson</h2>
            </div>
          </div>
        </section>
        <section className="frequency">
          <ul>
            <li>
              <button
                type="button"
                className="btn"
                onClick={() => {
                  setFrequency(0);
                  toggle();
                }}
              >
                Daily
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn"
                onClick={() => {
                  setFrequency(1);
                  toggle();
                }}
              >
                Weekly
              </button>
            </li>
            <li>
              <button
                type="button"
                className="btn"
                onClick={() => {
                  setFrequency(2);
                  toggle();
                }}
              >
                Monthly
              </button>
            </li>
          </ul>
        </section>
      </div>

      <div className="right">
        {frequency === 0 && <Daily />}
        {frequency === 1 && <Weekly />}
        {frequency === 2 && <Monthly />}
      </div>
    </>
  );
};

const Daily = () => {
  return data.map((card) => {
    i = i + 1;
    return (
      <section key={i} className={`cards ` + card.title}>
        <div className="upper">
          <h3 className="title">{card.title}</h3>
          <div className="option">
            <img src="./images/ellipsis.svg" alt="Option" />
          </div>
        </div>
        <div className="middle">
          <h2>{card.timeframes.daily.current}hrs</h2>
        </div>
        <div className="lower">
          <h4> Yesterday - {card.timeframes.daily.previous}hrs </h4>
        </div>

        <div className="time"></div>
      </section>
    );
  });
};

const Weekly = () => {
  return data.map((card) => {
    i = i + 1;
    return (
      <section key={i} className={`cards ` + card.title}>
        <div className="upper">
          <div className="title">{card.title}</div>
          <div className="option">
            <img src="./images/ellipsis.svg" alt="Option" />
          </div>
        </div>
        <div className="middle">
          <h2>{card.timeframes.weekly.current}hrs</h2>
        </div>
        <div className="lower">
          <h4>Last Week - {card.timeframes.weekly.previous}hrs </h4>
        </div>
      </section>
    );
  });
};

const Monthly = () => {
  return data.map((card) => {
    i = i + 1;
    return (
      <section key={i} className={`cards ` + card.title}>
        <div className="upper">
          <div className="title">{card.title}</div>
          <div className="option">
            <img src="./images/ellipsis.svg" alt="Option" />
          </div>
        </div>
        <div className="middle">
          <h2>{card.timeframes.monthly.current}hrs</h2>
        </div>
        <div className="lower">
          <h4> Last Month - {card.timeframes.monthly.previous}hrs </h4>
        </div>
      </section>
    );
  });
};

// let buttons = document.getElementsByClassName("btn");

// for(let i=0; i<buttons.length;i++){
//   buttons[i].addEventListener

// }

const toggle = () => {
  let buttons = document.querySelectorAll(".btn");
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      buttons.forEach((freq) => {
        if (freq.classList.contains("active")) {
          freq.classList.remove("active");
        }
      });

      button.classList.toggle("active");
    });
  });
};

export default Tracker;
